<template>
    <div>
      <!-- Tìm kiếm -->
  
      <div class="card mb-5 mb-3">
        <div class="card-header">
          <h3 class="card-title flex-row"><i class="fa fa-list"></i>
            <span class="card-label fs-3 ms-1">Quản lý nhà cung cấp</span>
          </h3>
        </div>
        <div class="card-body">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
              <label>Tên nhà cung cấp:</label>
              <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <el-input placeholder="Nhập tên nhà cung cấp" v-model="search.cTenNhaCungCap" />
                </el-col>
              </el-row>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
              <label>Trạng thái:</label>
              <el-row :gutter="10">
                <el-col :xs="20" :sm="22" :md="20" :lg="20" :xl="22">
                  <el-select placeholder="Chọn trạng thái" v-model="search.nTinhTrang">
                    <el-option label="Tất cả" value="5"></el-option>
                    <el-option label="Bình thường" value="1"></el-option>
                    <el-option label="Đã xóa" value="0"></el-option>
                  </el-select>
                </el-col>
                <el-col :xs="4" :sm="2" :md="4" :lg="4" :xl="2">
                  <el-button plain type="primary" title="Tìm kiếm" @click="handleFindPage"><i
                      class="fa fa-search"></i></el-button>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </div>
  
      <div class="card data-table mb-5 mb-xl-10">
        <div class="card-header py-3">
          <div class="form-row d-flex flex-row justify-content-between w-100">
            <div>
              <el-button type="primary" plain native-type="submit" @click="handleOpenAdd">
                <span class="btn-inner--icon"><i class="fas fa-plus"></i></span>
                <span class="btn-inner--text">&nbsp;Thêm nhà cung cấp</span>
              </el-button>
            </div>
            <div style="text-align:right">
              <el-button  plain style="margin-right:30px" title="Đồng bộ" type="warning"
                v-loading.fullscreen.lock="isLoading"><i class="el-icon-refresh"></i></el-button>
              <!-- <el-button plain icon="el-icon-s-grid" ></el-button> -->
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="col-md-12 tbl">
            <el-table :data="tableData.content" header-row-class-name="thead-light" style="height: 100%" height="100%" fit
              stripe highlight-current-row>
              <el-table-column prop="" type="index" label="STT" width="120"></el-table-column>
              <el-table-column prop="c_ten_nha_cung_cap" label="Tên nhà cung cấp" min-width="150"></el-table-column>
              <el-table-column prop="c_dia_chi" label="Địa chỉ" min-width="150"></el-table-column>
              <el-table-column prop="c_email" label="Email" min-width="150"></el-table-column>
              <el-table-column prop="c_sdt" label="Số điện thoại" min-width="150"></el-table-column>
              <el-table-column prop="d_ngay_tao" label="Ngày tạo" width="120">
                <template #default="scope">
                  <span v-if="scope.row.d_ngay_tao">{{
                    momentDate(scope.row.d_ngay_tao)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="n_tinh_trang" label="Trạng thái" width="120" align="center">
                <template #default="scope">
                  <el-tag type="success" v-if="scope.row.n_tinh_trang == 1" :size="size">Hoạt Động</el-tag>
                  <el-tag type="danger" v-if="scope.row.n_tinh_trang == 0" :size="size">Đã xóa</el-tag>
                </template>
              </el-table-column>
              <!-- Button hành động -->
              <el-table-column width="160" align="center">
                <template #default="scope">
                  <el-button type="primary" plain @click="handleOpenEdit(scope.row)"
                    :disabled="scope.row.n_tinh_trang == 0">
                    <span class="btn-inner--icon"><i class="fas fa-edit"></i></span>
                  </el-button>
  
                  <el-button type="danger" plain @click="handleDelete(scope.row)" :disabled="scope.row.n_tinh_trang == 0"
                    v-loading.fullscreen.lock="isLoading">
                    <span class="btn-inner--icon"><i class="fas fa-trash"></i></span>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
  
        <div class="col-12 py-2 pagination" style="justify-content: end">
          <el-pagination @size-change="handleChangePageSize" @current-change="handleChangePageNum"
            :current-page.sync="tableData.pageNum" :page-sizes="[5, 10, 20, 30, 40]" :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="tableData.totalSize">
          </el-pagination>
        </div>
      </div>
      <el-dialog v-model="centerDialogVisible" class="modalTemp" :show-close="false" dataBackDrop="static">
        <template #header="{ close, titleId, titleClass }">
          <div class="d-flex justify-content-between px-4">
            <h2 class="fw-bolder">{{ operation ? "Cập nhật" : "Thêm tin" }}</h2>
            <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal"
              @click="centerDialogVisible = false">
              <span class="svg-icon svg-icon-1">
                <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
              </span>
            </div>
          </div>
        </template>
        <el-form :model="validateForm" :rules="rules" ref="validateForm" label-width="150px"
          class="demo-ruleForm flex-column">
  
          <el-form-item label="Tên nhà cung cấp" prop="cTenNhaCungCap">
            <el-input :size="size" v-model="validateForm.cTenNhaCungCap"></el-input>
          </el-form-item>
          <el-form-item label="Địa chỉ" prop="cDiaChi">
            <el-input :size="size" v-model="validateForm.cDiaChi"></el-input>
          </el-form-item>
          <el-form-item label="Email" prop="cEmail">
            <el-input :size="size" v-model="validateForm.cEmail"></el-input>
          </el-form-item>
          <el-form-item label="SĐT" prop="cSDT">
            <el-input :size="size" v-model="validateForm.cSDT"></el-input>
          </el-form-item>
  
        </el-form>
        <template #footer>
          <el-button v-if="!operation" type="primary" @click="handleAdd()"
            v-loading.fullscreen.lock="isLoading">Thêm</el-button>
          <el-button v-if="operation" type="primary" @click="handleEdit()"
            v-loading.fullscreen.lock="isLoading">Lưu</el-button>
          <el-button plain type="danger" @click="handleClose">Thoát</el-button>
        </template>
      </el-dialog>
    </div>
  </template>
  <script>
  import moment from "moment";
  import { useStore } from "vuex";
  import { Supplier } from "@/store/enums/StoreEnums";
  import { ElMessage } from "element-plus";
  export default {
    data() {
      return {
        size: "",
        tableData: {
          content: [
          ]
        },
        search: {
          cTenNhaCungCap: "",
          nTinhTrang: "5",
        },
        isSearchLoading: false,
        isLoading: false,
        centerDialogVisible: false,
        operation: false,
        validateForm: {
          cTenNhaCungCap: "",
          cDiaChi: "",
          cEmail: "",
          cSDT: ""
        },
        rules: {
          cTenNhaCungCap: [
            { required: true, message: "Xin vui lòng nhập tên nhà cung cấp", trigger: "blur", },
          ],
          cDiaChi: [
            { required: true, message: "Xin vui lòng nhập địa chỉ", trigger: "blur", },
          ],
          cSDT: [
            { required: true, message: "Xin vui lòng nhập số điện thoại", trigger: "blur", },
          ],
        },
        productList: [],
        fit: "cover",
        pageRequest: {
          columnFilters: {},
          pageSize: 30,
          pageNum: 1
        },
        selected: {},
        store: useStore()
      };
    },
    methods: {
  
  
      handleFindPage() {
        this.isSearchLoading = true
        this.pageRequest.columnFilters = {
          cTenNhaCungCap: { value: this.search.cTenNhaCungCap },
          nTinhTrang: { value: this.search.nTinhTrang }
        }
        this.store.dispatch(Supplier.findPageSupplier, this.pageRequest).then(res => {
          if (res.code == 200) {
            this.tableData = res.data
            this.isSearchLoading = false
          } else {
            ElMessage({ message: "Có lỗi xảy ra xin vui lòng thử lại sau", type: "error" })
            this.isSearchLoading = false
          }
        })
      },
      handleOpenAdd() {
        this.validateForm = {
          cTenNhaCungCap: "",
          cDiaChi: "",
          cEmail: "",
          cSDT: ""
        }
        this.operation = false
        this.centerDialogVisible = true
      },
      handleAdd() {
        this.$refs.validateForm.validate((valid) => {
          if (valid) {
            let pageRequest = {
              columnFilters: {
                cTenNhaCungCap: { value: this.validateForm.cTenNhaCungCap },
                cDiaChi: { value: this.validateForm.cDiaChi },
                cEmail: { value: this.validateForm.cEmail },
                cSDT: { value: this.validateForm.cSDT },
              }
            }
            this.store.dispatch(Supplier.insertSupplier, pageRequest).then(res => {
              if (res.code == 200) {
                ElMessage({ message: res.msg, type: "success" })
                this.centerDialogVisible = false
                this.handleSearch()
              } else {
                ElMessage({ message: res.msg, type: "error" })
                this.centerDialogVisible = false
              }
            })
          }
        })
  
      },
      handleOpenEdit(val) {
        this.selected = Object.assign({}, val)
        this.validateForm = {
          cTenNhaCungCap: this.selected.c_ten_nha_cung_cap,
          cDiaChi: this.selected.c_dia_chi,
          cEmail: this.selected.c_email,
          cSDT: this.selected.c_sdt,
        }
        this.operation = true
        this.centerDialogVisible = true
      },
      handleEdit() {
        this.$refs.validateForm.validate((valid) => {
          if (valid) {
            let pageRequest = {
              columnFilters: {
                cTenNhaCungCap: { value: this.validateForm.cTenNhaCungCap },
                cDiaChi: { value: this.validateForm.cDiaChi },
                cEmail: { value: this.validateForm.cEmail },
                cSDT: { value: this.validateForm.cSDT },
                nMaNhaCungCap: { value: this.selected.n_ma_nha_cung_cap },
              }
            }
            this.store.dispatch(Supplier.updateSupplier, pageRequest).then(res => {
              if (res.code == 200) {
                ElMessage({ message: res.msg, type: "success" })
                this.handleSearch()
                this.centerDialogVisible = false
              } else {
                ElMessage({ message: res.msg, type: "error" })
                this.centerDialogVisible = false
              }
            })
          }
  
        })
      },
      handleDelete(val) {
        this.$confirm("Bạn có muốn xóa  không?", "Xác nhận", {
          confirmButtonText: "Xác nhận",
          cancelButtonText: "Hủy",
          type: "warning",
        })
          .then(() => {
            let pageRequest = {
              columnFilters: {
                nMaNhaCungCap: { value: val.n_ma_nha_cung_cap },
              }
            }
            this.store.dispatch(Supplier.deleteSupplier, pageRequest).then(res => {
              if (res.code == 200) {
                ElMessage({ message: res.msg, type: "success" })
                this.handleSearch()
                this.centerDialogVisible = false
              } else {
                ElMessage({ message: res.msg, type: "error" })
                this.centerDialogVisible = false
              }
            })
          })
      },
      handleSearch() {
        this.pageRequest.pageNum = 1
        this.handleFindPage()
      },
      handleChangePageNum(val) {
        this.pageRequest.pageNum = val
        this.handleFindPage()
      },
      handleChangePageSize(val) {
        this.pageRequest.pageSize = val
        this.handleFindPage()
      },
      handleClose() {
        this.centerDialogVisible = false
      },
      momentDate(val) {
        return val ? moment(val).format("DD/MM/YYYY") : ""
      }
    },
    mounted() {
      this.handleFindPage()
  
    },
  };
  </script>
  <style lang="scss" scoped>
  .tbl {
    height: calc(100vh - 255px);
  }
  
  .box-card {
    margin: 10px;
  }
  </style>
  